import classNames from "classnames"
import ApplicationComponent from "legacy/ApplicationComponent"
import { isPresent } from "legacy/helpers.es6"
import PropTypes from "prop-types"
import React from "react"

class LegacyButton extends ApplicationComponent {
  isProcessing() {
    return this.props.processing === true
  }

  icon() {
    const classes = { "fa-spinner-third fa-spin": this.isProcessing() }
    // The spinner is a Classic-only glyph; a kit-style caller must not
    // drag the spinner into the kit font while processing.
    const iconStyle = this.isProcessing() ? "solid" : this.props.iconStyle
    if (isPresent(this.props.icon) || this.isProcessing()) {
      if (!this.isProcessing()) {
        classes[this.props.icon] = true
      }
      return (
        <i
          className={classNames(
            `fa-${iconStyle}`,
            {
              "mr-2": !this.props.iconOnly,
              "btn-icon-only": this.props.iconOnly,
            },
            classes
          )}
        />
      )
    }
  }

  text() {
    if (this.isProcessing() && isPresent(this.props.processingText)) {
      return this.props.processingText
    } else {
      return this.props.children
    }
  }

  className() {
    let className = this.props.className
    if (this.props.iconOnly) {
      className = `${className} btn-icon-only`
    }
    if (this.props.type === "link") {
      return `text-link ${className || ""}`
    } else if (isPresent(this.props.type)) {
      return `btn btn-${this.props.type} ${className || ""}`
    } else if (isPresent(className)) {
      return className
    } else {
      return "btn btn-tertiary"
    }
  }

  render() {
    return (
      <button
        type="button"
        className={this.className()}
        disabled={this.isProcessing() || this.props.disabled}
        onClick={this.props.onClick}
        data-confirm={this.props.confirm}
        data-toggle={this.props.dataToggle}
      >
        {this.icon()}
        {this.text()}
      </button>
    )
  }
}

LegacyButton.propTypes = {
  type: PropTypes.string,
  icon: PropTypes.string,
  iconStyle: PropTypes.string,
  processing: PropTypes.bool,
  processingText: PropTypes.string,
  iconOnly: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  confirm: PropTypes.string,
  dataToggle: PropTypes.string,
}

LegacyButton.defaultProps = {
  iconStyle: "kit",
  processing: false,
  iconOnly: false,
  className: "",
  disabled: false,
}

export default LegacyButton
